import React from "react";
import { VegaButtonLink, VegaBox } from "@heartlandone/vega-react";
import { useNavigate} from 'react-router-dom';
import { ROUTES_PATH } from 'Chore/Constants';

function EditActivityAction({ activity }) {
  const { id } = activity;
  const navigate = useNavigate();

  const onEditActivityClick = () => {
    if(id) {
      navigate(`${ROUTES_PATH.EDIT_ACTIVITY}/${id}`);
    }
  };

  return (
    <VegaBox flexShrink={0} flexGrow={0}>
      <VegaButtonLink
        label="Edit Activity"
        icon="far fa-pen-to-square"
        onVegaClick={() => onEditActivityClick()}
      />
    </VegaBox>
  );
}

export default EditActivityAction;
